export enum Endpoints {
  CHANNEL = 'public/channels/{key}',
  CUSTOMER = 'customer',
  FORGOTTEN_PASSWORD = 'customer/password/remind',
  PASSWORD_RESET = 'customer/password/reset',
  UPDATE_CUSTOMER_CARD = 'customer/card',
  UPDATE_CUSTOMER_EMAIL = 'customer/email',
  UPDATE_CUSTOMER_DETAILS = 'customer/update-details',
  CONTENT_LIST = 'public/contents',
  PUBLIC_LIST = 'public/list',
  POLICY_APPLICATIONS = 'public/applications',
  POLICY_APPLICATION = 'public/applications/{id}',
  POLICY_APPLICATION_ISSUE = 'public/applications/{id}:issue',
  POLICY_APPLICATION_PAY = 'public/applications/{id}:pay',
  POLICY_DOCUMENTS_POLL = 'public/policy:documents-poll',
  DESTINATIONS = 'public/product-destinations',
  STATES = 'public/country-states?filter[country]=AU',
  INDUSTRIES = 'public/product-industries',
  OCCUPATIONS = 'public/product-occupations',
  SCREENING_START_CEGA = 'public/medical/cega:start',
  SCREENING_FINISH_CEGA = 'public/medical/cega:finish',
  SCREENING_START_HEALIX = 'public/medical/healix:start',
  SCREENING_FINISH_HEALIX = 'public/medical/healix:finish',
  POSTCODE_LOOKUP = 'public/french-postcode-search',
  POSTCODE_GET = 'public/address/{id}',
  TRANSACTION_PAY = 'public/transactions/{id}:pay',
  TRANSACTION_COMPLETE = 'public/transactions/{id}:complete-paybox',
  AGGREGATOR_POLICY_APPLICATION = 'aggregators/{id}',
  CAMPAIGN_CODE = '/public/campaigns/code/{code}',
  TRACKING_LINKS = 'public/broker/{id}',
  REFERRAL_QUOTE = 'public/applications/{id}:refer',
  FRENCH_COMMERCE_CHAMBERS = 'public/french-commerce-chambers',
  ADD_CLAIM = 'public/claims',
  PREMIUMS_BY_PAYMENT_SCHEDULES = 'public/premium-groups',
  DOC_RCP_PROPOSITION_ASSURANCE = 'public/doc/rcp-proposition-assurance',
  DOC_RCP_CONDITIONS_GENERALES = 'public/doc/rcp-conditions-generale',
  BI_ANNUAL_FIRST_AMOUNT = 'public/recurring-payment/first-amount/{id}',
  CHECK_EXISTING_CUSTOMER = 'public/customers/exists',
}
export function documentsPoll(documentsPollToken: string) {
  return axios
    .post(
      url(Endpoints.POLICY_DOCUMENTS_POLL),
      { documentsPollToken },
      { headers: { 'Content-Type': 'application/vnd.api+json' }},
    )
    .then((response) => {
      return response.data;
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/endpoints.ts